import { useState, useEffect } from "react";

/**
 * Hook to check if the current user session is an impersonation session.
 * Returns true if 'impersonationToken' exists in sessionStorage.
 */
export const useImpersonation = (): boolean => {
    const [isImpersonated, setIsImpersonated] = useState<boolean>(() => {
        return !!sessionStorage.getItem("impersonationToken");
    });

    useEffect(() => {
        const checkImpersonation = () => {
            const token = sessionStorage.getItem("impersonationToken");
            setIsImpersonated(!!token);
        };

        // Check immediately
        checkImpersonation();

        // Optional: Listen for storage events if impersonation status might change in another tab
        // or if we want to be reactive to sessionStorage changes within the same tab (though sessionStorage events are usually cross-tab)
        const handleStorageChange = () => {
             checkImpersonation();
        }
        
        window.addEventListener('storage', handleStorageChange);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return isImpersonated;
};
